module.exports = {
	"base": {
		"welcome": "ברוכים הבאים ל-Mulligans,‏ %{name}!",
		"user": "פרטי משתמש",
		"devices": "מכשירים",
		"refunds": "החזרים כספיים",
		"resources": "משאבים",
		"transactions": "הזמנות והחזרות",
		"email": "דואר אלקטרוני",
		"password": "סיסמה",
		"save": "שמור",
		"sign-out": "התנתק",
		"cancel": "ביטול",
		"close": "סגור",
		"learn-more": "למידע נוסף",
		"required": "נדרש",
		"support": "תמיכה",
		"bookshelf": "Bookshelf",
		"launch": "הפעל",
		"download": "הורד",
		"details": "פרטים",
		"cannot-be-blank": "%{field} לא יכול להישאר ריק.",
		"saving": "שומר...",
		"done": "בוצע",
		"failed": "נכשל",
		"copy": "העתקה"
	},
	"signin": {
		"login-failure": "הדואר האלקטרוני או הסיסמה שגויים",
		"welcome-large": "ברוך הבא אל <span class='inner'>%{brand} Account Center</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "התחברות",
		"forgot-password": "האם שכחת את הסיסמה",
		"new-to-vst": "חדש ב-%{brand}?",
		"create-account": "צור חשבון",
		"signing-in": "נכנס למערכת...",
		"signin-failed": "הכניסה נכשלה"
	},
	"transactions": {
		"price": "מחיר",
		"excluded": "(לא כולל מסים)",
		"quantity": "כמות",
		"confirmation#": "מספר אישור",
		"payment": "תשלום",
		"purchased": "נרכש",
		"purchase-details": "פרטי הרכישה",
		"subtotal": "סכום כולל",
		"total": "סך הכל",
		"tax": "מס",
		"loading": "תודה שקנית אצלנו, אנחנו טוענים את העסקאות שלך...",
		"no-purchases": "אין לך רכישות.",
		"seller-vat": "מע\"מ של המוכר",
		"total-vat": "סך %{vat} ששולם",
		"portion": "%{subTax} מס %{rate}%",
		"vat-disclosure": "המחיר כולל %{vat}",
		"purchases": "רכישות",
		"refunded-items": "פריטים שעליהם ניתן החזר כספי",
		"book-title": "כותרת הספר",
		"refund-details": "פרטי החזר",
		"print-receipt": "הדפס קבלה",
		"request-refund": "בקש החזר כספי",
		"expired": "פג תוקף",
		"expires-in": "תפוגה %{date}",
		"details-refund": "פרטים והחזר כספי",
		"modal": {
			"cant-refund-title": "החזר כספי אינו זמין",
			"cant-refund": "לא ניתן לקבל החזר כספי על הספר שלך בשל סיבה אחת או יותר מהבאות.",
			"cant-refund-1": "יותר מדי מהספר נצפה.",
			"cant-refund-2": "חלפו מעל 14 יום מאז תאריך הרכישה.",
			"cant-refund-3": "קוד המשאבים המקוונים נחשף.",
			"cant-refund-4": "כבר קיבלת החזר כספי בעבר על הספר.",
			"cant-refund-5": "כל הקודים כבר מומשו ו/או ניתן עליהם החזר כספי.",
			"cant-refund-6": "חלפו מעל 30 יום מאז תאריך הרכישה.",
			"cant-refund-support": "אם עדיין אינך בטוח לגבי מדיניות ההחזרים של %{brand}, פנה <a href='%{support_url}' target='_blank'>לתמיכה</a>."
		},
		"license": {
			"perpetual": "לגישה מקוונת אין תוקף",
			"days": "גישה למשך %{days} ימים"
		}
	},
	"devices": {
		"description": "%{brand} מאפשר לך להחזיק <span>%{desktop}</span> מחשבים ו- <span>%{mobile}</span> מכשירים ניידים/טאבלטים מופעלים בכל זמן נתון.",
		"loading": "הי, אנחנו מקבלים את המכשירים שלך :)",
		"no-active": "אין לך מכשירים פעילים.",
		"deactivate": "בטל הפעלה"
	},
	"user": {
		"personal-information": "מידע אישי",
		"security-information": "מידע אבטחה",
		"notifications": "התראות",
		"first-name": "שם פרטי",
		"last-name": "שם משפחה",
		"change-password-title": "שנה סיסמה",
		"current-password": "סיסמה נוכחית",
		"new-password": "סיסמה חדשה",
		"security-password": "סיסמה",
		"confirm-new-password": "אשר סיסמה חדשה",
		"security-question": "שאלת אבטחה",
		"security-info-change": "שנה",
		"question": "שאלה",
		"answer": "תשובה",
		"notifications-text": "שלחו לי מדי פעם עדכונים בדוא\"ל אודות הפעילות בחשבון שלי, עדכוני מוצרים והצעות מיוחדות.",
		"loading": "לאקי רץ להביא את פרטי המשתמש שלך, רק רגע 🐶",
		"change-password-text": "הסיסמה חייבת להכיל לפחות 8 תווים, אות גדולה, אות קטנה ותו מיוחד.",
		"email-locked": "כתובת הדוא\"ל נעולה",
		"email-locked-description": "אין לך גישה לשנות את כתובת הדוא\"ל שלך.",
		"email-locked-more": "פנה אל מנהל המערכת שלך.",
		"security-question6": "מהו הספורט החביב עליך?",
		"security-question7": "מהי הגלידה האהובה עליך?",
		"security-question8": "מהו שם חיית המחמד האהובה עליך?",
		"security-question9": "כשהיית קטן, מה רצית להיות כשתגדל?",
		"security-question10": "מה היה שם המשפחה של המורה החביב/ה עליך?",
		"new-password-failure": "הסיסמה אינה עומדת בדרישות",
		"confirm-password-failure": "הסיסמאות חייבות להתאים",
		"new-password-tooltip": "סיסמאות חייבות להכיל 8 תווים לפחות, אות גדולה, אות קטנה ותו מיוחד.",
		"enter-valid-email": "הזן דואר אלקטרוני חוקי.",
		"password-cannot-be-same": "הסיסמה לא יכולה להיות לזהה לסיסמה הקודמת",
		"incorrect-password": "סיסמה שגויה",
		"complete-account": "נראה כי עליך <a href='%{href}'>להשלים את החשבון שלך</a>.",
		"completing-allows": "השלמת החשבון מאפשרת לך לקרוא ספרים באופן לא מקוון באפליקציות שלך בנייד ולשתף הערות וסימונים עם חברים.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "מסייעים",
		"access-codes": "קודי גישה",
		"print-on-demand": "הדפסה לפי בקשה",
		"check-pod": "בדוק את אפשרויות ההדפסה של המוציא לאור עבור הספרים שלך.",
		"check-now": "בדוק כעת",
		"loading": "חכה רגע, אנחנו מעדכנים את המשאבים שלך!",
		"in": "ב-",
		"access-code-intro": "קוד גישה הוא סיסמה שבה נעשה שימוש כדי לגשת לתוכן של קורס מקוון. לאחר חשיפה קוד עבור פריט, לא תוכל להחזיר אותו. לקבלת הנחיות לשימוש בקודי גישה, בקר <a href='%{support_url}' target='_blank'>באתר התמיכה</a>.",
		"expires": "תפוגה",
		"expiration-message": "מכיל הוראות לשימוש בקוד הגישה שלך.",
		"copy-fail": "לא ניתן להעתיק. בחר את הקוד והעתק אותו ידנית.",
		"launch-site": "אתר הפעלה",
		"launch-book": "פתח את הספר",
		"reveal-code": "חשוף קוד",
		"no-resources": "אין לך משאבים.",
		"no-access-codes": "אין לך קודי גישה.",
		"no-ancillaries": "אין מסייעים לכותר זה",
		"name": "שם",
		"type": "סוג",
		"size": "גודל",
		"download-all": "הורד הכל",
		"back": "בחזרה למשאבים"
	},
	"refunds": {
		"states": {
			"refunded": "ניתן החזר כספי",
			"unavailable": "החזר כספי לא זמין"
		},
		"reasons": {
			"dropped": "נשרתי מהקורס",
			"wrong": "זה אינו הספר המתאים לקורס שלי",
			"print": "החלטתי לקנות גרסה מודפסת במקום זאת",
			"missing": "הספר לא מכיל את כל מה שאני צריך עבור הקורס (למשל, תקליטור, גישה לאינטרנט, סרטוני וידאו)",
			"other": "אחר"
		},
		"bulk": {
			"policy": "על-ידי לחיצה על הלחצן &quot;החזר כספי מלא&quot; להלן, אני מסכים <a href='%{policy_url}' target='_blank'>למדיניות ההחזרים של</a>%{brand}.",
			"complete": "החזר כספי מלא",
			"view-details": "הצג פרטי החזר כספי",
			"success": "בקשתך להחזר כספי נשלחה. יש להמתין 48 שעות להשלמת תהליך העיבוד.",
			"failure": "אופס - משהו השתבש! לצערנו, ההחזר הכספי שלך לא הושלם בהצלחה.",
			"retry": "נסה שוב",
			"support": "יצירת קשר עם התמיכה",
			"available-codes": "קודים זמינים",
			"codes-selected": "קודים שנבחרו",
			"download": "הורד קודים",
			"partially-refunded": "הוחזר חלקית",
			"pick-one": "עליך לבחור לפחות קוד אחד כדי לבצע החזר כספי"
		},
		"refund": "החזר כספי",
		"all": "לבצע החזר כספי להכל?",
		"missing-reason": "עליך לבחור סיבה כדי להמשיך",
		"missing-elaboration": "אנא פרט",
		"policy": "על-ידי לחיצה על הלחצן \"השלם בקשה להחזר כספי\" להלן, אני מאשר שאם ארכוש שוב ספר לימוד אלקטרוני זה של %{brand}, לא אהיה זכאי לבקש כל החזר כספי עבור אותו ספר לימוד אלקטרוני. הצג את מדיניות ההחזרים המלאה.",
		"refunded": "ניתן החזר כספי",
		"sorry": "אנו מצטערים שלא היית מרוצה מהרכישה שביצעת.",
		"error": "משהו השתבש",
		"error-explain": "לא הצלחנו לעבד את ההחזר הכספי שלך. נסה שוב.",
		"why": "ספר לנו מדוע?",
		"no-refunds": "אין לך פריטים עם החזר כספי.",
		"select-codes": "בחר קודים להחזר כספי:",
		"number": "כמה?",
		"back": "בחזרה להחזרים"
	},
	"purchases": {
		"back": "בחזרה לרכישות"
	},
	"global-bar": {
		"account": "הגדרות חשבון"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/he.json
 ** module id = 985
 ** module chunks = 0
 **/